import { mapNoiseReductionLevelFromSysApi } from '@shure/shared/angular/data-access/system-api/mappers';

import { NoiseReductionChannel } from '../../api';
import { NoiseReductionChannelFragment } from '../graphql/generated/noise-reduction.generated';

export function mapNoiseReductionChannelFromSysApi(channel: NoiseReductionChannelFragment): NoiseReductionChannel {
	const {
		id,
		features,
		description: { constraints }
	} = channel;
	return {
		id,
		name: channel.features.name?.name,
		features: {
			// FIXME: Replace
			noiseReduction: {
				enabled: features.noiseReduction?.enabled || false,
				level: mapNoiseReductionLevelFromSysApi(features.noiseReduction?.level),
				percentage: features.noiseReduction?.percentage ?? 0
			},
			channelConfiguration: channel.description.features.channelConfiguration.supported
				? {
						enabled: channel.features.channelConfiguration?.enabled || false,
						isMissing: channel.features.channelConfiguration === null
				  }
				: undefined
		},
		constraints: {
			validLevels:
				constraints.noiseReduction?.level?.options?.map((level) => mapNoiseReductionLevelFromSysApi(level)) ||
				[],
			intensityLevelRange: {
				min: constraints.noiseReduction?.percentage?.range?.min || 0,
				max: constraints.noiseReduction?.percentage?.range?.max || 100,
				step: constraints.noiseReduction?.percentage?.range?.step || 2
			}
		}
	};
}
